var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-subheading" }, [_vm._v("Status")]),
      _c(
        "md-radio",
        {
          staticClass: "md-primary",
          attrs: { "md-value": "archived" },
          on: { change: _vm.onChange },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [_vm._v(" Archived")]
      ),
      _c(
        "md-radio",
        {
          staticClass: "md-primary",
          attrs: { "md-value": "draft" },
          on: { change: _vm.onChange },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [_vm._v("    Draft")]
      ),
      _c(
        "md-radio",
        {
          staticClass: "md-primary",
          attrs: { "md-value": "public" },
          on: { change: _vm.onChange },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [_vm._v("   Live")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc317222", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc317222","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/StatusRadio.vue
// module id = 716
// module chunks = 0